import script from "./EmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailModal.vue?vue&type=script&setup=true&lang=js"

import "./EmailModal.vue?vue&type=style&index=0&id=07c6a99e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c6a99e"]])

export default __exports__